const { getCachedConfiguration } = require('@nuskin/configuration-sdk');
const { productNotFound } = require('../models');

// httpStatus codes
const httpStatus = { notFound: 404 };

/**
 * productNotFoundInterceptor returns a model "ProductNotFound" when the status code is Not Found.
 * Note: Do not polute this file. Create a new file for new interceptor.
 * 
 * @param {import('axios').AxiosError} error 
 * @returns {import('axios').AxiosResponse<import('../').EquinoxResponse>}
*/
function productNotFoundInterceptor(error) {
  const segments = 'catalogs/search';
  const { config, response } = error;

  if (response.status === httpStatus.notFound && config.url.includes(segments)) {
    const params = new URLSearchParams(config.url);
    const filterParam = Array.from(params.values())[0];
    const sku = getSKU(filterParam);

    if (sku !== null) {
      const market = getCachedConfiguration('Equinox_Markets').country_code;
      const response = {
        ...error.response,
        data: {
          product: [
            productNotFound({ identifier: sku, exists: false }, market)
          ]
        },
        statusText: getStatusText(error.response)
      };

      return response;
    }

    console.error('Unable to detect SKU from the given parameter', filterParam);
  }

  return Promise.reject(error);
}

/**
 * getSKU returns the SKU from the given parameter.
 * @param {string} param '\\''index_key_productId="02010489" OR index_key_skuId="02010489"'''
 * @returns {string|null} SKU 
 */
function getSKU(param) {
  const result = param.match(/\d{8}/);

  if (result === null) {
    return null;
  }

  return result[0];
}

/**
 * @param {import('axios').AxiosResponse<import('../').EquinoxErrorResponse>} [response] 
 * @returns {string}
 */
function getStatusText(response) {
  if (response) {
    const { code, message, timestamp } = response.data;
    return `Floating product found -- ${timestamp} ${code}: ${message}`;
  }

  return '';
}

module.exports = productNotFoundInterceptor;
